import React from 'react';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import { useGetAllInspectionStatusesSuspense } from '../../../../services/api/generated/client';
import UpdateInspectionStatusForm from './UpdateInspectionStatusForm';
import { useFeatureFlags } from '../../../../context/FeatureFlagProvider';
import { PENDING } from '../../../../constants/statuses';
const UpdateInspectionStatusFormWrapper = ({ onClose }) => {
    const { usePendingStatus } = useFeatureFlags();
    const { data: statusResponse } = useGetAllInspectionStatusesSuspense({
        query: { staleTime: Infinity },
    });
    const statuses = unwrapModel(statusResponse);
    if (!statuses)
        return null;
    const filteredStatuses = !usePendingStatus
        ? statuses.filter((status) => status.id !== PENDING)
        : statuses;
    return (React.createElement(UpdateInspectionStatusForm, { onClose: onClose, statuses: filteredStatuses }));
};
export default UpdateInspectionStatusFormWrapper;
